<template>
  <section>
    <div class="group-inline">
      <label>Font Size</label>
      <input class="group-inline__input" type="number" step="0.01" v-model.number="value.marker.fontSize">
    </div>
    
    <div v-if="value.marker && value.marker.padding" class="group-block">
      <label>Padding</label>
      <div class="group-block__inputs">
        <div class="group-block__input-wrapper">
          top <input class="group-block__input" type="number" step="0.01" v-model="value.marker.padding[0]">
        </div>
        <div class="group-block__input-wrapper">
          bottom <input class="group-block__input" type="number" step="0.01" v-model="value.marker.padding[2]">
        </div>
        <div class="group-block__input-wrapper">
          left <input class="group-block__input" type="number" step="0.01" v-model="value.marker.padding[3]">
        </div>
        <div class="group-block__input-wrapper">
          right <input class="group-block__input" type="number" step="0.01" v-model="value.marker.padding[1]">
        </div>
      </div>
    </div>

    <div class="group-inline">
      <label>Text Colour</label>
      <div
        class="btn-colour"
        :style="{ backgroundColor: value.marker.textColour }"
        @click="colourWidget === 'textColour' ? colourWidget = '' : colourWidget = 'textColour'"
      ></div>
    </div>
    <div v-if="colourWidget === 'textColour'" class="mb-2 mx-2">
      <verte display="widget" picker="square" model="rgb" v-model="value.marker.textColour"></verte>
    </div>

    <div class="group-inline">
      <label>Background Colour</label>
      <div
        class="btn-colour"
        :style="{ backgroundColor: value.marker.backgroundColour }"
        @click="colourWidget === 'backgroundColour' ? colourWidget = '' : colourWidget = 'backgroundColour'"
      ></div>
    </div>
    <div v-if="colourWidget === 'backgroundColour'" class="mb-2 mx-2">
      <verte display="widget" picker="square" model="rgb" v-model="value.marker.backgroundColour"></verte>
    </div>
    
    <div class="group-inline">
      <label>Tail Position</label>
      <select v-model="value.marker.tailPosition" class="group-inline__input">
        <option value="none">No Tail</option>
        <option value="bottom-left">Bottom Left</option>
        <option value="bottom-center">Bottom Center</option>
        <option value="bottom-right">Bottom Right</option>
        <option value="top-left">Top Left</option>
        <option value="top-center">Top Center</option>
        <option value="top-right">Top Right</option>
        <option value="left-center">Left Center</option>
        <option value="right-center">Right Center</option>
      </select>
    </div>
    <div class="group-inline">
      <label>Tail Height</label>
      <input class="group-inline__input" type="number" v-model.number="value.marker.tailHeight">
    </div>

    <div class="group-inline">
      <label>Rotation</label>
      <input class="group-inline__input" type="number" v-model.number="value.marker.rotation">
    </div>

    <div class="group-inline">
      <label>Box Shadow</label>
      <input class="group-inline__input" type="checkbox" v-model.number="value.marker.boxShadow">
    </div>

    <!-- <div class="group-inline mt-auto">
      <button class="btn btn-sm btn-danger mx-auto" @click="reset">Reset</button>
    </div> -->
  </section>
</template>
<script>
import Verte from 'verte'
import 'verte/dist/verte.css'

export default {
  props: ['value'],

  components: {
    Verte,
  },

  data () {
    return {
      colourWidget: ''
    }
  },

  methods: {
    reset () {
      if (window.confirm("Are you sure you want to reset the marker styles?")) {


        // const reset = {
        //   fontSize: 0.75,
        //   padding: [0.5, 1.1, 0.4, 1.1],
        //   textColour: '#000000',
        //   backgroundColour: '#FFFFFF',
        //   rotation: 0,
        //   boxShadow: true,
        //   tailHeight: 4,
        //   tailPosition: 'none',
        //   x: this.value.marker.x,
        //   y: this.value.marker.y,
        // }

        // this.$emit('input', reset)

      }
    }
  }
}
</script>
<style lang="scss" scoped>
.group-inline {
  align-items: center;
  display: flex;
  margin-bottom: 14px;

  label {
    margin: auto auto auto 0;
  }

  &__input {
    background-color: #fbfcfe;
    border: 1px solid rgba(96, 125, 159, 0.25);
    border-radius: 3px;
    box-shadow: inset 0 1px 4px -1px rgba(96, 125, 159, 0.25);
    font-size: 11px;
    margin: 0 0 0 10px;
    overflow: hidden;
    padding: 4px 5px;
  }
}

.group-block {
  align-items: center;
  display: flex;
  margin-bottom: 14px;

  label {
    margin: auto auto auto 0;
  }

  &__inputs {
    display: flex;
    flex-wrap: wrap;
    width: 152px;
  }

  &__input-wrapper {
    width: 50%;
  }

  &__input {
    background-color: #fbfcfe;
    border: 1px solid rgba(96, 125, 159, 0.25);
    border-radius: 3px;
    box-shadow: inset 0 1px 4px -1px rgba(96, 125, 159, 0.25);
    font-size: 11px;
    margin: 0;
    overflow: hidden;
    padding: 4px 5px;
    width: 100%;
  }
}

.btn-colour {
  border: 1px solid #111;
  border-radius: 3px;
  width: 22px;
  height: 22px;
}
</style>
